import { DEPRECATED_ApiManager } from "../../../api";

import { RecipeLoadResponse, RecipePromptSections, RecipeSummary, RunResults } from "./types";

export const createRecipeApi = (api: DEPRECATED_ApiManager) => ({
  list: (): Promise<{ recipes: RecipeSummary[] }> =>
    api.request({ method: "GET", url: "/api/browser_automation/recipes" }),

  save: (recipeId: string, sections: RecipePromptSections): Promise<{ recipe_id: string }> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "save", ...sections },
    }),

  load: (recipeId: string): Promise<RecipeLoadResponse> =>
    api.request({ method: "GET", url: `/api/browser_automation/recipes/${recipeId}` }),

  checkConnection: (): Promise<{ is_connected: boolean }> =>
    api.request({
      method: "GET",
      url: "/api/browser_agent/check_connection_status",
    }),

  run: (recipeId: string, userId: string): Promise<{ run_id: string; status: string }> =>
    api.request({
      method: "POST",
      url: `/api/browser_automation/recipes/${recipeId}/run`,
      body: { user_id: userId },
    }),

  pollStatus: (
    recipeId: string,
    runId: string
  ): Promise<{ run_id: string; status: string; error?: string }> =>
    api.request({
      method: "GET",
      url: `/api/browser_automation/recipes/${recipeId}/runs/${runId}/status`,
    }),

  getResults: (recipeId: string, runId: string): Promise<RunResults> =>
    api.request({
      method: "GET",
      url: `/api/browser_automation/recipes/${recipeId}/runs/${runId}/results`,
    }),

  publish: (
    recipeId: string,
    runId: string
  ): Promise<{
    manifest_entry: Record<string, unknown>;
    is_republish: boolean;
    was_prod_enabled: boolean;
  }> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "publish", run_id: runId },
    }),

  promote: (
    recipeId: string,
    prodEnabled: boolean
  ): Promise<{ recipe_id: string; prod_enabled: boolean }> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "promote", prod_enabled: prodEnabled },
    }),

  unpublish: (recipeId: string): Promise<{ recipe_id: string; unpublished: boolean }> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "unpublish" },
    }),

  deleteRecipe: (recipeId: string): Promise<{ recipe_id: string; deleted: boolean }> =>
    api.request({
      method: "DELETE",
      url: `/api/browser_automation/recipes/${recipeId}`,
    }),

  restoreFromPublished: (recipeId: string): Promise<RecipeLoadResponse> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "restore_from_published" },
    }),

  restoreFromRun: (recipeId: string, runId: string): Promise<RecipeLoadResponse> =>
    api.request({
      method: "PUT",
      url: `/api/browser_automation/recipes/${recipeId}`,
      body: { action: "restore_from_run", run_id: runId },
    }),
});
